module.exports = __webpack_public_path__ + "img/DK30733053.cf0e0dd0.png";